export const constant = {
  MOBILE_TIPS: "请输入手机号码",
  SEND_SUCCESSFULLY: "发送成功",
};
export const options = {
  ASIDE_MENU: [
    { label: "工作台", url: "/homePage", icon: "/static/icon/tab-bar/new-dashboard.svg", checkIcon: "/static/icon/tab-bar/new-dashboard_hover.png" },
    { label: "课堂", url: "/learning", icon: "/static/icon/tab-bar/new-discover.svg", checkIcon: "/static/icon/tab-bar/new-discover_hover.png" },
    // { label: "平台数据", url: "/analysis" },
    // { label: "应用列表", url: "/applet" },
    {
      label: "通讯录",
      url: "/organization", icon: "/static/icon/tab-bar/new-contacts.svg", checkIcon: "/static/icon/tab-bar/new-contacts_hover.png"
    },
    {
      label: "企业管理",
      url: "/manage",
      __AUTH_ARG: "A001", icon: "/static/icon/tab-bar/company.png", checkIcon: "/static/icon/tab-bar/company_hover.png",
      // children: [
      //   { label: "企业信息", url: "/manage/company" },
      //   {
      //     label: "成员管理",
      //     url: "/manage/member",
      //     __AUTH_ARG: "MEMBER_ALL",
      //   },
      //   {
      //     label: "设置主管理员",
      //     url: "/manage/admin-list",
      //     __AUTH_ARG: "A010",
      //   },
      //   {
      //     label: "设置子管理员",
      //     url: "/manage/setting-child",
      //     __AUTH_ARG: "A011",
      //   },
      //   {
      //     label: "应用权限设置",
      //     url: "/manage/permissions",
      //     __AUTH_ARG: "A005",
      //   },
      // ],
    },
    { label: "消息中心", url: "/information", icon: "/static/icon/tab-bar/new-message.svg", checkIcon: "/static/icon/tab-bar/new-message_hover.png" },
  ],
  NOTIFY_TYPE: {
    N001: { label: "系统通知", icon: "/static/icon/images/message/system.png" },
    N002: {
      label: "工作台助手",
      icon: "/static/icon/images/message/dashboard.png",
    },
    N003: {
      label: "活动通知",
      icon: "/static/icon/images/message/activity.png",
    },
    N004: { label: "应用权益", icon: "/static/icon/images/message/order.png" },
    N005: { label: "上新通知", icon: "/static/icon/images/message/gift.png" },
    N006: { label: "文件助手", icon: "/static/icon/images/message/files.png" },
    N000: {
      label: "应用通知",
      icon: "/static/icon/images/message/app_default.png",
    },
  },
};
export default {
  ...constant,
  ...options,
};
